module.exports = __webpack_public_path__ + "img/SES_192420256.c49208ce.jpg";